import { render, staticRenderFns } from "./PopupSlider.vue?vue&type=template&id=7d0d150e"
import script from "./PopupSlider.vue?vue&type=script&lang=js"
export * from "./PopupSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports